<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 shadow" 
         data-bs-scroll="true" 
         data-bs-backdrop="false" 
         tabindex="-1" 
         id="offcanvasDates" 
         aria-labelledby="offcanvasDateLabel"
         @blur="focusOff()"
         @focus="focusOn()"
      >
      <!--
         @blur="focusOff()"
         <button type="button" class="btn-close btn-sm text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref="btn_out_offcanvas"></button>
      -->
      <div class="offcanvas-header">
         <h6 id="offcanvasDatesLabel">Fechas ({{cnttId}})</h6>
         <button type="button" 
            id="btn_close_offcanvas"
            class="btn-close btn-sm text-reset" 
            data-bs-dismiss="offcanvas" 
            aria-label="Close" 
            ref="btn_close_offcanvas"
         ></button>
      </div>
      <hr class="m-0"/>
      <div class="offcanvas-body">
         <datepicker 
               v-model="date"
               inline
               autoApply
               locale="es"
               range
               selectText="Guardar"
               weekStart="0"
               :disabledWeekDays=arrDisabledWeekDays
               @internalModelChange="focusDp()"
               >
         </datepicker>
         <!--
               :disabledWeekDays="arrDisabledWeekDays"
               :disabledWeekDays="[6, 0]"
         -->
         <div class="row px-1 pt-2 gap-1">
            <div class="row row-cols-1 py-0 px-1">
               <b class="tc-gray fs-11">Fecha de Inicio</b>
               <h6>{{dateTime(date[0])}}</h6>
               <b class="tc-gray fs-11">Fecha de Vencimiento</b>
               <h6>{{dateTime(date[1])}}</h6>
            </div>
            <div class="fp-onOff btn-save rounded" @click="setDates(true)">
               Guardar
            </div>
            <div v-if="content.enableDates" class="fp-onOff btn-info rounded" @click="setDates(false)">
               Quitar
            </div>
         </div>
      </div>
   </div>
   </div>
</template>

<script>
//import { ref, watchEffect, nextTick } from 'vue';
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css';
import moment from 'moment';

import WspService from "../workSpace.service";

export default {
   
   components: {
      Datepicker
   },
   setup() {
      const store = useStore()

      const boardId = ref(null)
      const btn_out_offcanvas = ref(null)
      const cnttId = ref(store.state.wspace.contentId)
      const cellId = ref(0)
      const content = ref({})
      const date = ref([])
      const dateRange = ref(0)
      const arrDisabledWeekDays = ref([])

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasDates')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
         // do something...
         console.log(store.state.wspace.contentId)
         cnttId.value = store.state.wspace.contentId
         let button = event.relatedTarget
         cellId.value = button.getAttribute('data-cell-id')
         dateRange.value = Number(button.getAttribute('data-date-range'))
         arrDisabledWeekDays.value = []
         if (button.getAttribute('data-disable-week-days') == "true")
            arrDisabledWeekDays.value = [6, 0]
         boardId.value = WspService.getBoardId(store)
         getContent(cnttId.value)
         //getDates()
         /*
         */
         myOffCanvas.focus()
         console.log(" show date's OC")
         })
         console.log("date's OC")
      })
      /*
      watchEffect(() => {
         cnttId.value = store.state.wspace.contentId
      })
      */
      function dateTime(dtValue) {
         return moment(dtValue).format('DD-MM-YYYY HH:mm');
      }
      
      function addDays(date, days) {
         let result = new Date(date);
         if (arrDisabledWeekDays.value.length > 0) {
            let countDays = 0
            while (countDays < days) {
               result.setDate(result.getDate() + 1)
               if (!(result.getDay() == 6 || result.getDay() == 0))
                  countDays++
            }
         } else {
            result.setDate(result.getDate() + days);
         }
         return result;
      }
      
      function getContent(contentId) {
         WspService.getContent(contentId)
         .then(response => {
            console.log(response.data)
            content.value = response.data
            getDates()
            console.log("content ok: "+content.value.title)
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getDates() {

         let startDt = new Date()
         if (content.value.startDate != null)
            startDt = content.value.startDate

         //let endDt = addDays(startDt, 4)
         let endDt = addDays(startDt, dateRange.value)
         if (content.value.endDate != null)
            endDt = content.value.endDate
         
         date.value = [startDt, endDt]
      }
      
      function setDates (add) {
         let cnttData = {}
            cnttData.enableDates = add
            cnttData.userId = store.state.auth.user.id
         if (add) {
            cnttData.startDate = date.value[0]
            cnttData.endDate = date.value[1]
         }
         console.log("dates > "+add)
         WspService.upContent(
            cnttId.value,    // contentId,
            cellId.value,    // cellId,
            boardId.value,   // boardId
            'DTS',   // code
            cnttData    // cnttData
         )
         .then(response => {
            console.log("upDates > Id: "+response.data)
            getContent(response.data)
            store.dispatch("wspace/setContentId", -4)
            //
            //setTimeout(getContent(response.data),125)
            //
         })
         .catch(error => {
            console.log(error);
         });
         //store.dispatch("wspace/setContentId", -4)
      }

      function focusDp() {
         console.log('click-in-datepicker')
         //
         store.dispatch("wspace/setOffCanvas", 0)
         document.getElementById('offcanvasDates').focus()
         //setTimeout(btn_out_offcanvas.value.click(),125)
         //
      }

      function focusOff() {
         console.log('out-focus-offcanvas')
         //
         store.dispatch("wspace/setOffCanvas", 4)
         //setTimeout(btn_out_offcanvas.value.click(),125)
         //
      }

      function focusOn() {
         console.log('in-focus-offcanvas')
         //
         //setTimeout(btn_out_offcanvas.value.click(),125)
         //
      }

      return {
         cnttId,
         content,
         date,
         dateTime,
         arrDisabledWeekDays,
         setDates,
         focusDp,
         focusOn,
         focusOff,
         btn_out_offcanvas,
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 25px;
  right: 100px;
  width: 292px;
  height: fit-content;
}
/*
   width: max-content;
   width: 170px;
*/
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-save {
   opacity: .7;
   background-color: blue;
   color: white;
}
.btn-save:hover {
   opacity: 1;
}
.btn-sm {
   width: max-content;
}
.fp-onOff {
  width: 333px;
  height: 30px;
  text-align: center;
}
.tc-gray {
   color: gray;
}
.fs-11 {
   font-size: 11px;
}
</style>